/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Cuando completamos el formulario en Vue, debemos `}<em parentName="p">{`emitir`}</em>{` un evento con datos hacia el padre.`}</p>
    <p>{`En nuestro caso emitiremos el evento `}<inlineCode parentName="p">{`submit`}</inlineCode>{` y el ID del Pokémon ingresado.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`template`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`form`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokemon-form`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`on:`}</span>{`submit`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`handleSubmit`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`form`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`template`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`


`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`export default {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  name: 'PokedexForm',`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  data () {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    return {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      pokemonName: ''`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  },`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  methods: {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    search (e) {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      e.preventDefault()`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      const pokemonName = this.pokemonName`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      const newPokemonId = window.isNaN(parseInt(pokemonName)) ? pokemonName.toLowerCase() : pokemonName`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      this.$emit('submit', newPokemonId)`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    <p>{`Ahora necesitamos definir dentro de `}<inlineCode parentName="p">{`<Pokedex />`}</inlineCode>{` que vamos a escuchar el evento `}<inlineCode parentName="p">{`submit`}</inlineCode>{` y la función que ejecutaremos cuando esto ocurra.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// ...Pokedex.vue`}</span>{`
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`pokedex-form`}</span>{`
  `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`v-on:`}</span>{`submit`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`handleSubmit($event)`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{`
`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Pokedex.vue..`}</span>{`
`}</code></pre></div>
    <p>{`Finalmente creamos la función `}<inlineCode parentName="p">{`handleSubmit()`}</inlineCode>{` que validara el ID del Pokémon, actualizara el estado y finalmente realizara la petición a la API usando `}<inlineCode parentName="p">{`this.getPokemon()`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`//...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`export default {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  //...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  methods: {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    getPokemon () {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      //...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    },`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    handleSubmit (pokemonId) {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      if (pokemonId !== '') {`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        this.error = false`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        this.loading = true`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        this.pokemonId = pokemonId`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        this.getPokemon()`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        return`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      this.error = true`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  }`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;